import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardSocialCommon } from '../../../shared';

export const FeedCardSocial: FunctionComponent<FeedCardProps> = memo((props) => {
  return <FeedCardSocialCommon {...props} />;
});
